import {
    CursorBasedPaginationResponse,
    OffsetBasedPaginationResponse,
    QueryBaseTypeWithCursorPaginationWhereAndOrder,
    QueryBaseTypeWithOffsetPaginationWhereAndOrder,
    QueryBaseTypeWithOrder,
    QueryBaseTypeWithWhere,
    SortTypeEnum,
} from 'api/common';
import {SprintModel} from 'models/sprint.model';
import {BoardDefaultStatusType, ItemStatus} from '../ItemStatus.model';
import {FieldValues, ItemDataFieldModel} from './item_data_fields';
import {BoardFormSummaryViewsOwned} from '../boardDynamicForm.model';

export interface ItemDataCreateResponse {
    createItemData: ItemDataModel;
}
export interface ItemDataModel {
    active: boolean;
    createdBy?: string | null;
    createdDate?: string;
    deleted: boolean;
    deletedBy: string | null;
    id: string;
    isImportedData: boolean;
    itemStatusId: string;
    itemStatus?: ItemStatus;
    sprintId?: string;
    sprint?: SprintModel;
    url: string;
    lastModifiedDate: string | null;
    modifiedBy: string | null;
    order: number;
    ticketNo: number;
    data: ItemDataFieldModel[];
    createdByName?: string;
    summaryViews: Array<BoardFormSummaryViewsOwned>;
}
interface ItemDataListingResponse
    extends Omit<
        ItemDataModel,
        'isImportedData' | 'createdBy' | 'createdDate' | 'deleted' | 'deletedBy' | 'lastModifiedDate' | 'modifiedBy'
    > {}
// Respones interface
export interface ItemDataResponse extends ItemDataListingResponse {
    createdDate?: string;
}
export interface ItemDataCursorPaginationResponse {
    itemDatasWithCursorPagination: CursorBasedPaginationResponse<ItemDataResponse>;
}
export interface itemDataByOffsetPaginationResponse {
    itemDatasWithOffsetPagination: OffsetBasedPaginationResponse<ItemDataResponse>;
}
export interface ItemDataWithNoPaginationResponse {
    itemDatas: ItemDataResponse[];
}
//requert models

export interface itemDataQueryFiltes {
    ticketNo: number;
    data: Array<ItemDataFieldModel>;
    createdDate: string;
    itemStatus: {
        boardId: string;
        statusType: string;
        board: {id: string; slug: string; workspace: {id: string; tenantId: string}};
    };
}
interface ItemDataFiledsSearchFilters {
    value: FieldValues;
    fieldType: string;
    dataType: string;
    uniqueId: string;
}
interface ItemDataSearchFilters {
    search?: string;
    sort?: ItemDatSortInputType;
    dataFieldsFilters?: ItemDataFiledsSearchFilters[];
}
export type ItemDatSortInputType = {
    direction: SortTypeEnum;
    field: string;
};
export interface ItemDataFilterRequest {
    workspaceSlugs?: string[];
    sprintIds?: string[];
    boardSlugs?: string[];
    itemStatusIds?: string[];
    workspaceSlug?: string[];
    itemStatusTypes?: BoardDefaultStatusType[];
    filters?: ItemDataSearchFilters;
}
export interface ItemDataGetAllCursoPaginationRequest
    extends QueryBaseTypeWithCursorPaginationWhereAndOrder<itemDataQueryFiltes> {
    filters?: ItemDataFilterRequest;
}

export interface ItemDataGetAllByOffsetRequest
    extends QueryBaseTypeWithOffsetPaginationWhereAndOrder<itemDataQueryFiltes> {
    filters?: ItemDataFilterRequest;
}

export interface ItemDateGetAllWithoutPaginationRequest
    extends QueryBaseTypeWithWhere<itemDataQueryFiltes>,
        QueryBaseTypeWithOrder<ItemDataResponse> {
    filters?: ItemDataFilterRequest;
}

export type ItemDataCreateRequest = {
    data: Array<ItemDataFieldModel>;
    itemStatusId: string;
    url: string;
    sprintId?: string;
    summaryViews: Array<BoardFormSummaryViewsOwned>;
};

export type ItemDataUpdateRequest = {
    data: Array<ItemDataFieldModel>;
    id: string;
    itemStatusId: string;
    order: number;
    url: string;
    sprintId?: string | null;
    ticketNo?: number;
};
export const itemDataUpdateRequestDefault: ItemDataUpdateRequest = {
    data: [],
    id: '',
    itemStatusId: '',
    url: '',
    order: 0,
};
export interface UpdateItemDataOrderAndStatusesRequest {
    order: number;
    itemStatusId: string;
    id: string;
    sprintId?: string;
    ticketNo?: number;
}

export interface UpdateItemDataStatesRequest {
    itemStatusId: string;
    itemIds: string[];
}

export interface UpdateItemDataSprintRequest {
    sprintId: string;
    itemIds: string[];
}

export interface TransferItemsRequest {
    sprintId?: string;
    itemStatusId: string;
    itemIds: string[];
}

export interface ItemDataUpdateOrderAndStatuesResponse {
    draggedItemId?: string;
    prevStatusId?: string;
    newStatusId: string;
}
